import * as Yup from 'yup';
import { INVALID_EMAIL, PASSWORD_MIN_LENGTH, MOBILE_INVALID, USERNAME_REQUIRED, NAME_REQUIRED, EMAIL_REQUIRED, MOBILE_REQUIRED, ROLE_REQUIRED, PASSWORD_REQUIRED } from '../../constant/message';

export const validationSchema = Yup.object().shape({
  clientId:Yup.number().required("Kindly select client"),
  userId:Yup.number().required("Select the name of the booking representative")
});